import styled from 'styled-components';
import {Button} from './Button';

export const ModalButton = styled(Button)`
  margin: 0 auto;
  font-weight: bold;
  text-transform: capitalize;
  min-width: 140px;
`;
